import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getRolesListFetchSuccess, getRolesListFetchFailure } from './reducer';
import { RolesListResType } from 'src/types/rolesList';

const getRolesListFetchRequest = async () => {
    const res = await api('get', 'api/secure/roles/permission');
    return res.data.data;
};

function* getRolesListFetch(action: { type: string }) {
    try {
        const response: RolesListResType = yield call((): any => getRolesListFetchRequest());
        yield put(getRolesListFetchSuccess(response));
    } catch (error) {
        yield put(getRolesListFetchFailure({ error }));
    }
}

export function* getRolesListFetchWatch() {
    yield takeEvery('rolesList/getRolesListFetch', getRolesListFetch);
}
